import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Main() {
  const [videoError, setVideoError] = useState(false);
  const videoRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => {
          // Video started playing
        })
        .catch(error => {
          console.log('Error starting video playback:', error);
        });
      }
    }
  }, []);

  return (
    <main className="main">
      {!videoError && (
        <video ref={videoRef} className="main__video" loop muted autoPlay>
          <source src="/videos/Map-main.mp4" type="video/mp4" />
        </video>
      )}
      {videoError && (
        <div className="main__video-error">
          <p>Sorry, the video could not be loaded.</p>
        </div>
      )}
      <div className="main-button-container">
        <Link to="/scenario-builder">
            <div>
              <img
                  className="logo"
                  src={isHovered ? '/images/Indego Station Planner-03.png' : '/images/Indego Station Planner-02.png'}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
              ></img>
            </div>
            <p className="main-button-L blinking-box" >Go to Planner</p>
        </Link>
        <div>
          <img className="logo-s" src='/images/weitzman.png'></img>
          <img className="logo-s" src='https://www.art-reach.org/wp-content/uploads/2021/06/logo-1-300x119.png'></img>
        </div>
        <p className="vedio-ref">The video we are using is owned by Indego. All rights reserved.</p>
      </div>

        {/* <div><img className="logo" src='https://www.art-reach.org/wp-content/uploads/2021/06/logo-1-300x119.png'></img></div> */}



    </main>
  );
}

export default Main;
